import { CardId } from './types';
import { ReceiptStatisticsTotals } from 'store/organisation/models';

export type CaptureStatCardStage = 'pending-review' | 'reviewed' | 'posted';

export type CaptureStatCardConfig = {
  metricKey: keyof ReceiptStatisticsTotals;
  stage: CaptureStatCardStage;
};

export const CAPTURE_STAT_CARD_CONFIG: Partial<
  Record<CardId, CaptureStatCardConfig>
> = {
  capturePendingReview: {
    metricKey: 'filesPendingReview',
    stage: 'pending-review',
  },
  captureReadyToPost: {
    metricKey: 'filesReviewed',
    stage: 'reviewed',
  },
  capturePostedFiles: {
    metricKey: 'postedThisMonth',
    stage: 'posted',
  },
  captureFilesUploaded: {
    metricKey: 'uploadedFilesTotal',
    stage: 'posted',
  },
};

export const CAPTURE_STAT_CARD_IDS = Object.keys(
  CAPTURE_STAT_CARD_CONFIG
) as CardId[];
